import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-456efa38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { key: 2 }

import {LeftCircleOutlined, RightCircleOutlined} from "@ant-design/icons-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SlideView',
  props: {
    toggle: { type: Boolean }
  },
  emits: ['update:toggle'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "navigation-box",
      style: _normalizeStyle({width:_ctx.toggle ? '80px' : '160px'})
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:toggle', !_ctx.toggle)))
      }, [
        (_ctx.toggle)
          ? (_openBlock(), _createBlock(_unref(RightCircleOutlined), { key: 0 }))
          : (_openBlock(), _createBlock(_unref(LeftCircleOutlined), { key: 1 })),
        (!_ctx.toggle)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "收起"))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})